module.exports = __webpack_public_path__ + "static/media/Aqi-Good.12e928ee.png";